import { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'beam/dist/styles'
import { withTranslation } from 'react-i18next'
import SpeechHit from './SpeechHit'
import EVENT_TYPE from '../../const/eventType'
import { isEmpty } from 'lodash'
import { difference } from '../../../../Common/Utils'

const styles = theme => ({
  graphContainer: {
    position: 'relative',
    paddingLeft: theme.spacing(0.5),
  },
  svg: {
    display: 'block',
  },
  hitsBorder: {
    stroke: theme.palette.grey[500],
  },
  hitsMidline: {
    stroke: theme.palette.grey[400],
    strokeDasharray: '4',
  },
})

class SpeechHitsGraphTape extends Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    graphHeight: PropTypes.number.isRequired,
    heightUnitsPerMs: PropTypes.number.isRequired,
    callDurationMs: PropTypes.number.isRequired,
    audioOffsetMs: PropTypes.number.isRequired,
    speechHits: PropTypes.array,
    t: PropTypes.func,
    classes: PropTypes.object,
    theme: PropTypes.object,
    zoomed: PropTypes.bool,
    setTime: PropTypes.func,
  }

  static defaultProps = {
    t: str => str,
    zoomed: false,
    setTime: () => {},
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propsChanged = !isEmpty(difference(nextProps, this.props))
    const stateChanged = !isEmpty(difference(nextState, this.state))
    return propsChanged || stateChanged
  }

  render() {
    const {
      width,
      graphHeight,
      heightUnitsPerMs,
      classes,
      theme,
      t,
      audioOffsetMs,
      speechHits,
      zoomed,
      setTime,
    } = this.props

    const eventLanePadding = theme.spacing(1)

    return (
      <div className={classes.graphContainer}>
        <svg width={width} height={graphHeight} className={classes.svg}>
          <line x1={0} y1={0} x2={0} y2={graphHeight} className={classes.hitsBorder} />
          <line
            x1={(width - eventLanePadding) * 0.25}
            y1={0}
            x2={(width - eventLanePadding) * 0.25}
            y2={graphHeight}
            className={classes.hitsMidline}
          />
          <line
            x1={(width - eventLanePadding) * 0.5}
            y1={0}
            x2={(width - eventLanePadding) * 0.5}
            y2={graphHeight}
            className={classes.hitsMidline}
          />
          <line
            x1={(width - eventLanePadding) * 0.75}
            y1={0}
            x2={(width - eventLanePadding) * 0.75}
            y2={graphHeight}
            className={classes.hitsMidline}
          />
          <line
            x1={width - eventLanePadding}
            y1={0}
            x2={width - eventLanePadding}
            y2={graphHeight}
            className={classes.hitsBorder}
          />
          {speechHits &&
            speechHits.map((hit, i) => (
              <SpeechHit
                key={i}
                size={zoomed ? 16 : 4}
                event={{
                  ...hit,
                  eventType: EVENT_TYPE.TRANSCRIPTION_HIT,
                  contactOffset: audioOffsetMs + hit.start,
                  duration: hit.stop - hit.start,
                }}
                heightUnitsPerMs={heightUnitsPerMs}
                t={t}
                theme={theme}
                containerWidth={width}
                eventMaxWidth={width - eventLanePadding /*Because of padding*/}
                setTime={setTime}
                showPhrase={zoomed}
              />
            ))}
        </svg>
      </div>
    )
  }
}

export { SpeechHitsGraphTape as UnstyledSpeechHitsGraphTape }

export default withTranslation()(withStyles(styles, { withTheme: true })(SpeechHitsGraphTape))
